export interface AssigneeEntry {
  label: string;
  value: string; // worker_id
  volume: number;
}

export function calculateTotalVolume(users: AssigneeEntry[]): number {
  if (!users || users.length === 0) return 0;
  return users.reduce((acc, user) => acc + (user.volume || 0), 0);
}

export function redistributeEqualVolume(individuals: AssigneeEntry[]): void {
  const count = individuals.length;
  if (count === 0) return;
  const base = Math.floor(100 / count);
  const remainder = 100 % count;
  const arr = Array(count).fill(base);
  for (let i = 1; i <= remainder; i++) {
    arr[count - i] += 1;
  }
  individuals.forEach((ind, i) => {
    ind.volume = arr[i];
  });
}

export function calculateSpecificPercentageRemainingVolume(users: AssigneeEntry[]): number {
  return 100 - calculateTotalVolume(users);
}

export function calculateSpecificCountRemainingVolume(
  users: AssigneeEntry[],
  assignableCount: number
): number {
  if (!assignableCount) return 0;
  return assignableCount - calculateTotalVolume(users);
}

export function validAssignedVolume(
  individuals: AssigneeEntry[],
  volumeType: 'PERCENTAGES' | 'COUNT',
  max: number
): boolean {
  const total = calculateTotalVolume(individuals);
  if (volumeType === 'PERCENTAGES') return total >= 0 && total <= 100;
  if (volumeType === 'COUNT') return total >= 0 && total <= max;
  return false;
}

export function validSubmittedVolume(
  individuals: AssigneeEntry[],
  volumeType: 'PERCENTAGES' | 'COUNT',
  unassignedCount: number
): boolean {
  const total = calculateTotalVolume(individuals);
  if (total === 0) return true;
  if (volumeType === 'PERCENTAGES') return total === 100;
  if (volumeType === 'COUNT') return total === unassignedCount;
  return false;
}
